@if (!skeletonView) {
  <div class="grid">
    @for (good of prettyOrder.cart.goods; track good) {
      <div class="head-wrapper">
        <app-heading [headTooltip]="good.name$ | async"
          [subtitle]="'ORDERS.COMMON.CART.properties' | translate:({quantity: good.quantity, price: good.price | projectCurrency})"
          [title]="good.name$ | async"
          class="name"
          hAlign="center"
          titleFontWeight="500">
        </app-heading>
      </div>
    }
    <div class="info">
      <span class="cart-info-item" [matTooltip]="'ORDERS.COMMON.CART.total_price_tooltip' | translate">
        <mat-icon color="primary">attach_money</mat-icon>
        {{ prettyOrder.cart.totalPrice | projectCurrency }}
      </span>
      <span class="cart-info-item" [matTooltip]="'ORDERS.COMMON.CART.shipping_cost_tooltip' | translate">
        <mat-icon color="primary">local_shipping</mat-icon>
        {{ prettyOrder.shippingCost | projectCurrency }}
      </span>
      <span class="cart-info-item" [matTooltip]="'ORDERS.COMMON.CART.total_quantity_tooltip' | translate">
        <mat-icon color="primary">local_grocery_store</mat-icon>
        {{ 'ORDERS.COMMON.CART.total_quantity' | translate:({quantity: prettyOrder.cart.totalQuantity}) }}
      </span>
      <span class="cart-info-item" [matTooltip]="'ORDERS.COMMON.CART.weight_tooltip' | translate">
        <mat-icon color="primary">layers</mat-icon>
        {{ 'ORDERS.COMMON.CART.weight' | translate:({weight: prettyOrder.cart.totalWeight}) }}
      </span>
    </div>
  </div>
} @else {
  <div class="grid">
    <ngx-skeleton-loader [count]="2" [theme]="{
      borderRadius: '20px',
      minWidth: '260px',
      maxWidth: '280px',
      height: '50px',
      marginBottom: '5px'
    }">
    </ngx-skeleton-loader>
    <ngx-skeleton-loader class="info skeleton-info"
      [count]="4"
      [theme]="{ height: '15px', marginBottom: '0' }">
    </ngx-skeleton-loader>
  </div>
}
